import { render } from "./HeadBlock.vue?vue&type=template&id=98cad756"
import script from "./HeadBlock.vue?vue&type=script&lang=js"
export * from "./HeadBlock.vue?vue&type=script&lang=js"

import "./HeadBlock.vue?vue&type=style&index=0&id=98cad756&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__